import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export function ImportSectionsDialogErrorState() {
  const { t } = useTranslation();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" height="100%" gap={0.25} sx={{ pv: 3 }}>
      <ErrorOutlineRounded color="error" sx={{ fontSize: '5rem', paddingBottom: '1rem' }} />
      <Typography color="error" variant="h6" fontWeight={600}>
        {t('library.import_sections_error_title')}
      </Typography>
      <Typography color="error" variant="body1">
        {t('library.import_sections_error_message')}
      </Typography>
    </Stack>
  );
}
